import React from 'react';

const VideoYoutube = ({ url }) => {
  // Función para extraer el ID del video de diferentes formatos de URL de YouTube
  const getYoutubeVideoId = (url) => {
    if (!url) return '';
    
    // Patrones de URL de YouTube
    const patterns = [
      /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([^&]+)/,
      /(?:https?:\/\/)?(?:www\.)?youtube\.com\/embed\/([^?]+)/,
      /(?:https?:\/\/)?(?:www\.)?youtu\.be\/([^?]+)/
    ];
    
    for (let pattern of patterns) {
      const match = url.match(pattern);
      if (match) return match[1];
    }
    
    return '';
  };

  const videoId = getYoutubeVideoId(url);

  if (!videoId) {
    return (
      <div className="p-4 text-red-500">
        URL de video inválida
      </div>
    );
  }

  return (
    <div className="ratio ratio-1x1 w-100">
    <iframe
      src={`https://www.youtube.com/embed/${videoId}`}
      title="YouTube video player"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  </div>
  );
};

export default VideoYoutube;